import moment from 'moment';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import styled, { withTheme } from 'styled-components';
import {
  CardText,
  Card,
  CardLabel,
  CardContent,
} from 'components/Card/cardStyle';
import Container from 'components/Container';
import { useDuplicateEvent } from 'components/Events/gql';
import Icon from 'components/Icon';
import { CancelModal } from '../CancelModal';
import GetEvent from './gql/get-events';
// span, not div — it renders inside CardContent, which is a <p>.
const PassColor = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background-color: ${(props) => props.color};
`;

const Event = ({ data, theme, match, location, history }) => {
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState();

  const duplicateEvent = useDuplicateEvent();

  const type = -1 === location.pathname.indexOf('track') ? 'series' : 'track';

  // Context-aware route prefix (MANDATORY per CLAUDE.md). This page is only
  // routed under /admin today, but links must derive the prefix regardless.
  const routePrefix = location.pathname.includes('admin-track')
    ? '/admin-track'
    : location.pathname.includes('admin-employee')
    ? '/admin-employee'
    : '/admin';

  if (!data.getEvent) return false;

  return (
    <Container>
      <div style={{ padding: 20 }}>
        <Card key={data.getEvent.id}>
          <CardText>
            <CardLabel style={{ width: '15%' }}>Date:</CardLabel>
            <CardContent style={{ width: '85%' }}>
              {data.getEvent.fullDate
                ? moment(data.getEvent.fullDate, 'MM-DD-YYYY').format(
                    'MMM DD - YYYY'
                  )
                : ''}
            </CardContent>
          </CardText>
          <CardText>
            <CardLabel style={{ width: '15%' }}>Name:</CardLabel>{' '}
            <CardContent style={{ width: '85%' }}>
              <Link
                style={{
                  color: theme.colors.primary,
                }}
                to={{
                  pathname: `${routePrefix}/events/menu/${data.getEvent.id}`,
                  state: { event: data.getEvent },
                }}
              >
                {data.getEvent.name}
              </Link>
            </CardContent>
          </CardText>
          <CardText>
            <CardLabel style={{ width: '15%' }}>Track:</CardLabel>{' '}
            <CardContent style={{ width: '85%' }}>
              {data.getEvent.track.name}
            </CardContent>
          </CardText>
          <CardText>
            <CardLabel style={{ width: '40%' }}>Pass Color:</CardLabel>{' '}
            <CardContent style={{ width: '20%' }}>
              <PassColor
                color={data.getEvent.color_code ? data.getEvent.color_code : ''}
              />
            </CardContent>
          </CardText>
          <CardText>
            <CardLabel style={{ width: '15%' }}>Status:</CardLabel>{' '}
            <CardContent style={{ width: '85%', textTransform: 'capitalize' }}>
              {data.getEvent.status}
            </CardContent>
          </CardText>

          <CardText>
            <CardContent style={{ marginLeft: 0, textTransform: 'capitalize' }}>
              <Link
                style={{
                  color: theme.colors.primary,
                }}
                to={`${routePrefix}/${type}/${match.params.id}/events/${
                  data.getEvent.id
                }/participants?date=${moment(
                  data.getEvent.start_date,
                  'MM-DD-YYYY'
                ).format('YYYY-MM-DD')}`}
              >
                {process.env.REACT_APP_PLATFORM !== 'tickethoss'
                  ? 'Participants List'
                  : 'Tickets List'}
              </Link>
            </CardContent>
          </CardText>

          <Icon
            icon="edit"
            size={18}
            color={theme.colors.primary}
            padding="0 15px 0 0"
            onClick={async () => {
              history.push(
                `${routePrefix}/events/editEvent/${data.getEvent.id}`
              );
            }}
          />
          <Icon
            icon="cancel-event"
            size={22}
            color={theme.colors.primary}
            onClick={() => {
              setShowCancelModal(true);
              setSelectedEvent(data.getEvent);
            }}
          />
          <Icon
            icon="duplicate"
            size={22}
            color={theme.colors.primary}
            onClick={async () => {
              if (
                window.confirm('Are you sure you want to duplicate this event?')
              ) {
                const response = await duplicateEvent(data.getEvent.id);
                if (!response || response.errors) {
                  toast.error('Could not duplicate this event');
                } else {
                  toast.success('Event successfully duplicated');
                  window.location.href = `${routePrefix}/events/upcoming`;
                }
              }
            }}
            padding="0 0 0 15px"
          />
        </Card>
      </div>
      {showCancelModal ? (
        <CancelModal
          close={() => setShowCancelModal(false)}
          selectedEvent={selectedEvent}
          allEvents={data.getEventsAdmin.results}
          currentType={
            match.url.includes('track')
              ? 'track'
              : match.url.includes('series')
              ? 'series'
              : null
          }
          objectId={match.params.id}
        />
      ) : null}
    </Container>
  );
};

export default withTheme(GetEvent(Event));
